export const RouteNames = {
  HOME: 'HOME',
  CONTACT_US: 'CONTACT_US',
  POLLING_LOCATOR: 'POLLING_LOCATOR',
  MENU_DETAILS: 'MENU_DETAILS',
  SEARCH_RESULTS: 'SEARCH_RESULTS',
  CONTENT_DETAILS: 'CONTENT_DETAILS',
  STATISTICS: 'STATISTICS',
} as const;

export type RouteNamesKey = keyof typeof RouteNames;
